//import Vue from "vue";
import api from "../ApiBase";

export default {
  async getUnmappedItemsCount(selectedGroups, selectedGroup) {
    /**
     * Get the count of unmapped sales items for the side menu badge
     * @param {Array} selectedGroups - Array of selected group IDs
     * @param {string} selectedGroup - Currently selected group ID
     */
	console.log(api);
    if (selectedGroups.length > 0 && selectedGroup) {
      const response = await api.get(`GetUnmappedItemsCount`, {
        params: {
          echtId: selectedGroup,
        },
      });
      console.log("Unmapped Items Count Response:", response.data);
      if (response.data.length === 0) {
        return 0;
      } else {
        return response.data[0].count;
      }
    }
  },

  /**
   * Get the count of unmapped employees for the side menu badge
   */
  async getUnmappedEmployeesCount(selectedGroups, selectedGroup) {
    /**
     * Get the count of unmapped employees for the side menu badge
     * @param {Array} selectedGroups - Array of selected group IDs
     * @param {string} selectedGroup - Currently selected group ID
     */
    if (selectedGroups.length > 0 && selectedGroup) {
      let queryString = selectedGroups
        .map((id) => `echtId=${id}`)
        .join("&");
      const response = await api.get(
        `GetUnmappedEmployeesCount?${queryString}`
      );
      if (response.data == 0) {
        return 0;
      } else {
        return response.data;
      }
    } else {
      return 0;
    }
  },
};
